import _objectSpread from "D:/progect/guowai/ex_express_web/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import _toConsumableArray from "D:/progect/guowai/ex_express_web/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.search.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.function.name.js";
import { mapActions } from 'vuex';
import utils from '@/utils';
import table from '@/mixins/crud-table.js';
export default {
  mixins: [table],
  components: {
    componentForm: function componentForm() {
      return import('./form');
    }
  },
  render: function render() {
    var _this = this;

    var h = arguments[0];
    var page = h("d2-container", {
      "attrs": {
        "spacious": true
      }
    }, [h("d2-search-panel", {
      "slot": "header",
      "model": {
        value: _this.search.panel.active,
        callback: function callback($$v) {
          _this.$set(_this.search.panel, "active", $$v);
        }
      }
    }, [h("d2-bar", {
      "slot": "title"
    }, [h("d2-bar-space"), this.p('query') ? h("d2-bar-cell", [this.vNodePaginationMini]) : h("d2-bar-cell", [this.vNodeSearchPanelAlertNoPermissionQuery]), h("d2-bar-space"), h("d2-bar-cell", [h("el-button-group", [this.p('query') ? this.vNodeButtonSearch : null, this.vNodeButtonTableColumnsFilterTrigger])])]), this.p('query') ? this.vNodeSearchForm : null]), this.vNodeTable, h("d2-bar", {
      "slot": "footer"
    }, [h("d2-bar-cell", [this.vNodePaginationFull]), h("d2-bar-space")]), h("component-form", {
      "ref": "form",
      "on": {
        "success": this.research
      }
    }), this.vNodeTableColumnsFilter]);
    return page;
  },
  data: function data() {
    return {
      api: {
        index: 'RECORD_USER_PAY_ALL',
        delete: 'RECORD_USER_PAY_DELETE'
      },
      permission: {
        query: '',
        add: '',
        edit: '',
        detail: '',
        remove: '',
        express_record: ''
      }
    };
  },
  computed: {
    // 配置项
    // 表格列
    // 建议的书写顺序 [prop] -> [label] -> [align] -> [minWidth][width] -> [fixed] -> [other] -> [render][formatter] -> [if][show]
    settingColumns: function settingColumns() {
      var h = this.$createElement;
      return [{
        prop: 'id',
        label: this.$t('id'),
        minWidth: '80px'
      }, {
        prop: 'market_id',
        label: this.$t('market_mobile'),
        minWidth: '120px',
        render: function render(_ref) {
          var row = _ref.row;
          return h("d2-dict", {
            "attrs": {
              "name": "table_market_id",
              "value": row.market_id,
              "custom": true
            }
          });
        }
      }, {
        prop: 'order_no',
        label: this.$t('order_no'),
        minWidth: '140px'
      }, {
        prop: 'trade_no',
        label: this.$t('trade_no'),
        width: '120px'
      }, {
        prop: 'user_mobile',
        label: this.$t('user_mobile'),
        width: '150px'
      }, {
        prop: 'delivery_count',
        label: this.$t('delivery_count'),
        width: '150px'
      }, {
        prop: 'sum_count',
        label: this.$t('sum_count'),
        width: '150px'
      }, {
        prop: 'pay_total_fee',
        label: this.$t('pay_total_fee'),
        width: '150px',
        formatter: function formatter(row) {
          return row.pay_total_fee ? row.pay_total_fee / 100 : '0';
        }
      }, {
        prop: 'pay_mType',
        label: this.$t('pay_mType'),
        width: '120px',
        render: function render(_ref2) {
          var row = _ref2.row;
          return h("d2-dict", {
            "attrs": {
              "name": "pay_type",
              "value": row.pay_type
            }
          });
        }
      }, {
        prop: 'pay_status',
        label: this.$t('pay_status'),
        width: '120px',
        render: function render(_ref3) {
          var row = _ref3.row;
          return h("d2-dict", {
            "attrs": {
              "name": "pay_status",
              "value": row.pay_status
            }
          });
        }
      }, {
        prop: 'pay_dType',
        label: this.$t('pay_dType'),
        width: '120px',
        render: function render(_ref4) {
          var row = _ref4.row;
          return h("d2-dict", {
            "attrs": {
              "name": "pay_action_type",
              "value": row.pay_dType
            }
          });
        }
      }, // { prop: 'pay_info_xml', label: 'pay_info_xml', width: '120px' },
      {
        prop: 'pay_type',
        label: this.$t('pay_type'),
        width: '160px',
        render: function render(_ref5) {
          var row = _ref5.row;
          return h("d2-dict", {
            "attrs": {
              "name": "pay_type",
              "value": row.pay_type
            }
          });
        }
      }, {
        prop: 'end_time',
        label: this.$t('end_time'),
        width: '160px',
        formatter: function formatter(row) {
          return utils.time.format1(row.end_time, 'YYYY/M/D HH:mm:ss');
        }
      }, {
        prop: 'uptime',
        label: this.$t('uptime'),
        width: '160px',
        formatter: function formatter(row) {
          return utils.time.format1(row.uptime, 'YYYY/M/D HH:mm:ss');
        }
      }, {
        prop: 'ctime',
        label: this.$t('ctime'),
        width: '160px',
        formatter: function formatter(row) {
          return utils.time.format1(row.ctime, 'YYYY/M/D HH:mm:ss');
        }
      }].map(function (setting) {
        setting.sortable = 'custom';
        return setting;
      });
    },
    // 配置项
    // 表格操作列配置
    settingActionsConfig: function settingActionsConfig() {
      var _this2 = this;

      return function (_ref6) {
        var row = _ref6.row;
        return _toConsumableArray(_this2.p('express_record', [{
          icon: 'el-icon-collection',
          label: _this2.$t('express-record'),
          action: function action() {
            return _this2.goExpressRecord(row.order_no);
          }
        }], []));
      };
    },
    // 配置项
    // 表格搜索条件
    // 建议的书写顺序 [prop] -> [label] -> [default] -> [render] -> [if][show]
    settingSearch: function settingSearch() {
      var _this3 = this;

      var h = this.$createElement;
      return [{
        prop: 'market_mobile',
        label: this.$t('market_mobile'),
        default: utils.cookies.get('phone'),
        render: function render() {
          return h("el-input", {
            "style": "width:120px;",
            "attrs": {
              "disabled": true
            },
            "model": {
              value: _this3.search.form.model.market_mobile,
              callback: function callback($$v) {
                _this3.$set(_this3.search.form.model, "market_mobile", $$v);
              }
            }
          });
        } // render: () => <d2-dict-select name="search_market_id" vModel={ this.search.form.model.market_id } style="width:140px;" custom clearable/>

      }, {
        prop: 'user_mobile',
        label: this.$t('user_mobile'),
        default: '',
        render: function render() {
          return h("el-input", {
            "style": "width:200px;",
            "attrs": {
              "clearable": true
            },
            "model": {
              value: _this3.search.form.model.user_mobile,
              callback: function callback($$v) {
                _this3.$set(_this3.search.form.model, "user_mobile", $$v);
              }
            }
          });
        }
      }, {
        prop: 'start_time',
        label: this.$t('start_time'),
        default: '',
        render: function render() {
          return h("el-date-picker", {
            "attrs": {
              "value-format": "yyyy-MM-dd",
              "type": "date",
              "placeholder": "start_time"
            },
            "style": "width:130px;",
            "model": {
              value: _this3.search.form.model.start_time,
              callback: function callback($$v) {
                _this3.$set(_this3.search.form.model, "start_time", $$v);
              }
            }
          });
        }
      }, {
        prop: 'end_time',
        label: this.$t('end_time'),
        default: '',
        render: function render() {
          return h("el-date-picker", {
            "attrs": {
              "value-format": "yyyy-MM-dd",
              "type": "date",
              "placeholder": "end_time"
            },
            "style": "width:130px;",
            "model": {
              value: _this3.search.form.model.end_time,
              callback: function callback($$v) {
                _this3.$set(_this3.search.form.model, "end_time", $$v);
              }
            }
          });
        }
      }];
    }
  },
  methods: _objectSpread(_objectSpread({}, mapActions('d2admin/page', ['closeBy'])), {}, {
    goOrderBoxData: function goOrderBoxData(wash_id) {
      this.closeBy(function (page) {
        return page.name === 'management-wash-order-box';
      });
      this.$router.push({
        name: 'management-wash-order-box',
        query: {
          wash_id: wash_id
        }
      });
    },
    goOrderClothData: function goOrderClothData(wash_id) {
      this.closeBy(function (page) {
        return page.name === 'management-wash-order-cloth';
      });
      this.$router.push({
        name: 'management-wash-order-cloth',
        query: {
          wash_id: wash_id
        }
      });
    },
    goOrderPayData: function goOrderPayData(wash_id) {
      this.closeBy(function (page) {
        return page.name === 'management-wash-order-pay';
      });
      this.$router.push({
        name: 'management-wash-order-pay',
        query: {
          wash_id: wash_id
        }
      });
    },
    goOrderPreferData: function goOrderPreferData(wash_id) {
      this.closeBy(function (page) {
        return page.name === 'management-wash-order-prefer';
      });
      this.$router.push({
        name: 'management-wash-order-prefer',
        query: {
          wash_id: wash_id
        }
      });
    },
    goOrderAdminRecordData: function goOrderAdminRecordData(wash_id) {
      this.closeBy(function (page) {
        return page.name === 'management-wash-admin-record';
      });
      this.$router.push({
        name: 'management-wash-admin-record',
        query: {
          wash_id: wash_id
        }
      });
    },
    goExpressRecord: function goExpressRecord(order_no) {
      this.closeBy(function (page) {
        return page.name === 'management-record-ab-used';
      });
      this.$router.push({
        name: 'management-record-ab-used',
        query: {
          order_no: order_no
        }
      });
    },
    loadDict: function loadDict() {
      this.loadDictOne({
        name: 'search_market_id',
        method: this.$api.MARKET_ALL,
        fields: 'id,market_mobile',
        path: 'list',
        label: 'market_mobile',
        value: 'id'
      });
      this.loadDictOne({
        name: 'table_market_id',
        method: this.$api.MARKET_ALL,
        fields: 'id,market_mobile',
        path: 'list',
        label: 'market_mobile',
        value: 'id'
      });
    }
  })
};